import React, { useCallback, useEffect, useState } from 'react';
import DisruptiveAnalytics from './DisruptiveAnalytics';
import AnalyticsLegacyV2 from './AnalyticsLegacyV2';
import '../styles/analytics-switch.css';

/**
 * Alternador entre o Dashboard Analítico v3 (novo) e a v2 (anterior).
 *
 * Existe para que a v3 possa ir a produção sem virar caminho único: se algo
 * aparecer só com dado real, dá para voltar na hora, sem deploy.
 *
 * TEMPORÁRIO POR CONSTRUÇÃO. Enquanto existir, as duas versões vão no bundle
 * (a v2 pesa ~13 kB). Quando a v3 for aprovada, apagar este arquivo,
 * AnalyticsLegacyV2.js, styles/analytics-grid.css e styles/analytics-switch.css,
 * e apontar a rota direto para DisruptiveAnalytics.
 */

const CHAVE = 'rf.analytics.versao';

/** localStorage pode lançar (modo privado, storage desabilitado) — a escolha de
 *  layout nunca deve derrubar a tela. */
const lerPreferencia = () => {
  try {
    return window.localStorage.getItem(CHAVE) === 'v2' ? 'v2' : 'v3';
  } catch {
    return 'v3';
  }
};

const AnalyticsSwitch = () => {
  const [versao, setVersao] = useState(lerPreferencia);

  useEffect(() => {
    try {
      window.localStorage.setItem(CHAVE, versao);
    } catch {
      /* preferência não persiste; a sessão atual segue funcionando */
    }
  }, [versao]);

  const escolher = useCallback((v) => () => setVersao(v), []);

  return (
    <div className="rf-switch-wrap">
      <div
        className="rf-switch"
        role="group"
        aria-label="Versão do dashboard analítico"
      >
        <span className="rf-switch__label">Layout</span>
        <div className="rf-switch__group">
          <button
            type="button"
            onClick={escolher('v3')}
            aria-pressed={versao === 'v3'}
            className={`rf-switch__btn${versao === 'v3' ? ' is-on' : ''}`}
          >
            v3 <span className="rf-switch__tag">novo</span>
          </button>
          <button
            type="button"
            onClick={escolher('v2')}
            aria-pressed={versao === 'v2'}
            className={`rf-switch__btn${versao === 'v2' ? ' is-on' : ''}`}
          >
            v2 <span className="rf-switch__tag">anterior</span>
          </button>
        </div>
      </div>

      {/* Remontagem completa ao trocar (key): as duas versões têm layouts e
          medições de gráfico diferentes, e o recharts guarda dimensões em
          estado. Sem a key, o gráfico da nova versão herdaria a medição da
          antiga e desenharia com o tamanho errado até o próximo resize. */}
      {versao === 'v3' ? (
        <DisruptiveAnalytics key="v3" />
      ) : (
        <AnalyticsLegacyV2 key="v2" />
      )}
    </div>
  );
};

export default AnalyticsSwitch;
